<script setup>
  import { ref, computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { useUserStore } from "@/stores/UserStore";
  import Toggle from '@/components/controls/Toggle.vue';
  import useLegacyBridge from "@/composables/useLegacyBridge";

  const { markerBuilder } = useLegacyBridge();

  const emit = defineEmits(['station-active:change']);

  const props = defineProps({
    station: {
      type: Object,
      required: true
    },
    color: {
      type: String,
      required: true
    },
    activeStationCount: {
      type: Number,
      required: true
    }
  });

  const userStore = useUserStore();

  const { t } = useI18n();

  const stationActive = ref(true);
  
  const spotMarker = computed(() => markerBuilder(markerSettings.value).getIconElementString());
  const stationHeight = computed(() => props.station.data_values[0].station_elevation ? `${props.station.data_values[0].station_elevation} ft` : 'N/A');
  const disabled = computed(() => stationActive.value && props.activeStationCount <= 1)

  const markerSettings = computed(() => ({
    degrees: props.station.data_values[0][parseInt(props.station.data_names.indexOf('dir'))],
    provider: props.station.provider,
    mesonet: props.station.mesonet_name,
    status: props.station.status_id,
    spotType: props.station.type,
    iconType: "svg",
    iconSVGStrokeWidth: 1.5,
  }))

  function handleStationActiveChange() {
    emit('station-active:change', { station_id: props.station.station_id, active: stationActive.value });
  }

</script>

<template>
  <div 
    :key="props.station.station_id" 
    class="jwx-multi-station-list__station"
  >
    <div class="jwx-multi-station-list__station-name">
      {{ props.station.name }}
    </div>
    <div class="jwx-multi-station-list__station-body">
      <div class="jwx-multi-station-list__station-marker">
        <span v-html="spotMarker"></span>
      </div>
      <div class="jwx-multi-station-list__station-wind-speed">
        {{ props.station.data_values[0][parseInt(props.station.data_names.indexOf('avg'))] }} <span class="jwx-multi-station-list__station-wind-unit">{{ userStore.units.wind }}</span>
      </div>
      <Toggle
        @input:change="handleStationActiveChange"
        class="jwx-multi-station-list__station-toggle"
        :name="`multi-station-item-${props.station.station_id}`" 
        :id="`multi-station-item-${props.station.station_id}`"
        :color="`#${props.color}`"
        :disabled="disabled"
        size="small"
        v-model="stationActive"
      />
      <div class="jwx-multi-station-list__station-values">
        <div class="jwx-multi-station-list__station-height">
          {{ t('containers.windGraphs.heightLabel', { height: stationHeight }) }}
        </div>
        <div class="jwx-multi-station-list__station-wind-desc">
          {{ props.station.data_values[0][parseInt(props.station.data_names.indexOf('wind_desc'))] }}
        </div>
      </div>
    </div>
  </div>
</template>